import { useEffect, useState } from "react"

/** Countdown ms until ISO deadline; updates every 250ms. */
export function useDeadlineCountdown(deadlineAt: string | null | undefined): number {
  const [remainingMs, setRemainingMs] = useState(0)

  useEffect(() => {
    if (!deadlineAt) {
      setRemainingMs(0)
      return
    }

    const tick = () => {
      const end = Date.parse(deadlineAt)
      if (!Number.isFinite(end)) {
        setRemainingMs(0)
        return
      }
      setRemainingMs(Math.max(0, end - Date.now()))
    }

    tick()
    const id = setInterval(tick, 250)
    return () => clearInterval(id)
  }, [deadlineAt])

  return remainingMs
}

export function formatCountdown(ms: number): string {
  const totalSec = Math.ceil(ms / 1000)
  const m = Math.floor(totalSec / 60)
  const s = totalSec % 60
  return `${m}:${s.toString().padStart(2, "0")}`
}
